import AppendRoot from '@component/appendRoot'
import usePopup from './usePopup'
import { useEffect } from 'react'
import { isFunction } from 'lodash-es'

export default function MapboxPopupBase({
  lng,
  lat,
  ops,
  children,
  marker,
  onLoad
}) {

  const { popup, box } = usePopup({ lng, lat, ops })
  useEffect(() => {
    if (!popup || !marker) return
    marker.setPopup(popup)

    return () => {
      popup.remove()
    }

  }, [marker, popup])

  useEffect(() => {
    popup && isFunction(onLoad) && onLoad(popup)
  }, [popup, onLoad])

  return popup && (
    <AppendRoot container={box}>
      {children}
    </AppendRoot>
  )
}